import template from './loansSignUpForm.html';
import controller from './loansSignUpForm.controller';
import './loansSignUpForm.scss';

let loansSignUpFormComponent = {
  restrict: 'E',
  bindings: {
    loan: '<',
    simulation: '<',
    backSimulation: '<',
    loanPurposes: '<',
    onCancelCreateLoan: '&',
    onCreateLoan: '&',
    housingChange: '<',
    housingLoan: '<',
    isVariousCredit: '<',
    onOpenDetail: '&',
    isMobileApp: '<'
  },
  template,
  controller,
};

export default loansSignUpFormComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansSignUp/loansSignUpForm/loansSignUpForm.component.js